import http from 'axios'

export default {
  getResumeParcellaire: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/referentiel-parcellaire?anneeRecolte=${anneeRecolte}&codeTypeCulture=${codeTypeCulture}`)
  }
}
